import { makePost } from './ServiceManager';

const generatePdfAsync = async (pdfData) => {
  try {
    const result = await makePost('generate-pdf', { pdfData });
    return result;
  } catch (error) {
    return { error };
  }
};

export default generatePdfAsync;



// WEBPACK FOOTER //
// ./src/services/PDFManager.js